import { Navigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { useMemo, useState } from "react";
import { AuthError } from "@supabase/supabase-js";

export default function Logout() {
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(true);
  const [logoutError, setLogoutError] = useState<AuthError | null>(null);

  useMemo(() => {
    logout().then(res => {
      if (res.error !== null) {
        setLogoutError(res.error);
      }
      setIsLoggingOut(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isLoggingOut && logoutError === null) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {isLoggingOut && <div>Logging out...</div>}
      {!isLoggingOut && logoutError && (
        <div>
          <p>Error During Logout: {logoutError.message}</p>
          <p>Error Code: {logoutError.code}</p>
          <p>
            Please contact support for assistance: <b>hello@easyzilla.com</b>
          </p>
        </div>
      )}
    </>
  );
}
